import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import LineinputV2 from '../../../common/lineinputV2'
import { Checkbox, FormControlLabel } from '@mui/material'
import { Box, Button } from '@mui/material'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { navigation3 } from '../../../common/helper'
import DropDownOA from '../../../common/dropDownOA'
import { useEffect, useState } from 'react'
import Modal from '../../../common/modal'
import useToken from '../../../helpers/useTokens'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useTranslation } from '../../../../i18n/I18nProvider'

export const AddEditRouteModal = (props) => {
  const { idEdit = false, cityList = [], routeZones = [], item } = props
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const setModal = useSetAtom(modalAtom)
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)

  const {
    loginData: { intCompanyID, intUserID },
  } = useToken()

  const [selectedCity, setSelectedCity] = useState('')
  const [selectedRouteZone, setSelectedRouteZone] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [routeName, setRouteName] = useState('')
  const [routeAreas, setRouteArea] = useState('')
  useEffect(() => {
    if (item?.CityID) {
      setSelectedCity(cityList.find((city) => city.CityID === item.CityID))
      setSelectedRouteZone(routeZones.find((zone) => zone.id === item.RoueZoneID))
      setSelectedStatus(item.IsActive)
      setRouteName(item.RouteName)
      setRouteArea(item.RouteArea)
    }
  }, [item])
  const handleCreateRoute = () => {
    if (!selectedCity.CityID || !selectedRouteZone.id || !routeName || !routeAreas) {
      setAlert({ open: true, message: tr('rmPleaseFillAll', 'Please fill all fields'), severity: 'error' })
      return
    }
    const data = {
      RouteID: item?.RouteID || 0,
      CompanyID: intCompanyID,
      CityID: selectedCity.CityID,
      RouteZoneID: selectedRouteZone.id,
      RouteZone: selectedRouteZone.name,
      RouteName: routeName,
      RouteArea: routeAreas,
      IsActive: selectedStatus ? 1 : 0,
      UserID: intUserID,
    }
    setLoader(true)
    PostRequest(urls.cargoRoutesInsertUpdate, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.Message || tr('requestFailed', 'Request Failed'))
        }
        setAlert({ show: true, msg: idEdit ? tr('rmRouteUpdated', 'Route Updated !!!') : tr('rmRouteCreated', 'Route Created !!!'), success: true })
        setModal(null)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message || tr('rmFailedCreate', 'Failed to create route') })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  return (
    <Modal headTxt={idEdit ? tr('rmEditRoute', 'Edit Route') : tr('rmCreateNewRoute', 'Create New Route')} width={'80%'} updateModal={setModal}>
      <Box sx={{ display: 'flex', gap: '12px', margin: '12px' }} className="itemButtons">
        <Item sx={{ ...sx.itemsx, flex: 1 }}>
          <DropDownOA
            id={'city-select'}
            label={tr('selectCity', 'Select City')}
            data={cityList}
            value={selectedCity?.CityName || ''}
            defaultvalue={selectedCity?.CityName || ''}
            idKey={`CityID`}
            dataKey={`CityName`}
            onSelect={(val) => {
              setSelectedCity(val)
            }}
            searchPlaceholder={``}
            width="100%"
            nextId={`route-zone`}
            prevId={``}
            disabled={idEdit}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, flex: 1 }}>
          <DropDownOA
            id={'route-zone'}
            label={tr('rmRouteZone', 'Route Zone')}
            data={routeZones}
            value={selectedRouteZone?.name || ''}
            defaultvalue={selectedRouteZone?.name || ''}
            idKey={`id`}
            dataKey={`name`}
            onSelect={(val) => {
              setSelectedRouteZone(val)
            }}
            searchPlaceholder={``}
            width="100%"
            nextId={`status`}
            prevId={`city-select`}
            disabled={idEdit}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, flex: 1 }}>
          <div className={'input--wrapper'} style={{ width: '100%', margin: 0 }}>
            <LineinputV2
              id={'define-route-name'}
              type="text"
              label={tr('rmDefineRouteName', 'Define Route Name')}
              value={routeName}
              onBlur={(e) => setRouteName(e.target.value)}
              disabled={idEdit}
            />
          </div>
        </Item>
      </Box>
      <Box sx={{ display: 'flex', gap: '12px', margin: '12px' }} className="itemButtons">
        <Item sx={{ ...sx.itemsx, flex: 20 }}>
          <div className={'input--wrapper'} style={{ width: '100%', margin: 0 }}>
            <LineinputV2
              id={'define-route-areas'}
              type="text"
              label={tr('rmDefineRouteAreas', 'Define Route Areas')}
              value={routeAreas}
              onBlur={(e) => setRouteArea(e.target.value)}
            />
          </div>
        </Item>
        <Item sx={{ ...sx.itemsx, flex: 1 }}>
          <FormControlLabel
            value="end"
            control={<Checkbox checked={selectedStatus === 1} id={`route-status`} />}
            label={tr('gsActive', 'Active')}
            onChange={(event) => {
              setSelectedStatus(event.target.checked ? 1 : 0)
            }}
            labelPlacement="end"
          />
        </Item>
        <Item sx={{ ...sx.itemsx, flex: 1 }} className="disabled-wrapper">
          <Button
            variant="contained"
            id="LoadBtn"
            sx={{ paddingY: '7px !important', height: '36px' }}
            className="btn btn-primary"
            onClick={handleCreateRoute}
            onKeyDown={(e) => navigation3(e, 'newAddBtn', 'Hamali_Type', () => {})}
          >
            {idEdit ? tr('gsUpdate', 'UPDATE') : tr('create', 'CREATE')}
          </Button>
        </Item>
      </Box>
    </Modal>
  )
}
